<div class='row m-b-10'>
    <div class='col-sm-12'>
        <label>{{TR 'Text'}}</label>
        <textarea id='js-text-value' class='form-control full-width' rows='3' name='long_value'>{{text}}</textarea>
    </div>
</div>
